module.exports = require("@swa-ui/placements/src/BannerWithCard/BannerWithCardLayout1.module.scss");